import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withLoader from 'components/Shared/withLoader';
import { fetchDepotsGestion } from 'store/depotGestion/depotGestionActions';
import { invalidateReclamationQualifications } from 'store/reclamation/detailsActions';
import { fetchReclamationQualificationsIfNeeded } from 'store/reclamation/detailsActions';


import DemanderRetourDepuisUnMagasinContent from './DemanderRetourDepuisUnMagasinContent';
import { ReclamationQualificationDetailCodes } from '../../../../../constants';

const DemanderRetourDepuisUnMagasinContentWithLoader = withLoader(DemanderRetourDepuisUnMagasinContent);

class DemanderRetourDepuisUnMagasinContentContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchDepotsGestion();
        await this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.reclamationId !== this.props.reclamationId) {
            await this.props.invalidateReclamationQualifications();
            await this.props.fetchReclamationQualificationsIfNeeded(this.props.reclamationId);
        }
    }


    render() {
        const { onChange, action, depotsGestion, depot } = this.props;

        let depotGestionIndex = depotsGestion.findIndex(x => (x.codeDepot + ' - ' + x.nom) === depot);

        return (
            <DemanderRetourDepuisUnMagasinContentWithLoader
                isLoading={this.props.isLoading}
                onChange={onChange}
                action={action}
                depotsGestion={depotsGestion}
                depotGestionIndex={depotGestionIndex}
            />
        );
    }


}



DemanderRetourDepuisUnMagasinContentContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};


const mapStateToProps = (state, props) => {
    let qualifications = state.reclamation.details.qualifications;
    let depotDetails = qualifications ? state.reclamation.details.qualifications.details.find(x => x.code === ReclamationQualificationDetailCodes.Depot) : null;
    let depot = depotDetails ? depotDetails.value : '';

    return {
        depotsGestion: state.depotGestion.depotsGestion.items,
        depot: depot,
        isLoading: state.depotGestion.depotsGestion.isLoading || state.reclamation.details.isQualificationsLoading    
    };
};


const mapDispatchToProps = dispatch => ({
    fetchDepotsGestion: () => dispatch(fetchDepotsGestion()),
    invalidateReclamationQualifications: () => dispatch(invalidateReclamationQualifications()),
    fetchReclamationQualificationsIfNeeded: id => dispatch(fetchReclamationQualificationsIfNeeded(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(DemanderRetourDepuisUnMagasinContentContainer);